import styled, {css} from "styled-components";

interface IGroupFiltersListGroupTitleActivePreviewBoxProps {
    isVisible: boolean;
}

export const FilterPreviewDefaultBox = styled.span<IGroupFiltersListGroupTitleActivePreviewBoxProps>`

    @keyframes introAnimation {
        0% {
            opacity: 0;
            max-height: 0;
        }
        50% {
          opacity: 0;
          max-height: 20px;
        }
        100% {
            opacity: 1;
            max-height: 20px;
        }
    }

    display: block;
    opacity: 0;
    font-size: 11px;
    color: ${props => props.theme.colors.textLight};
    ${({theme}) => theme.font.presets.regular};
    text-transform: capitalize;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
    max-height: 0;

    ${props => props.isVisible && css`
      animation: 0.1s introAnimation 0.2s ease-in forwards;
    `}
`;
